// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"81954674","516":"eb94e772","566":"fd3ec976"}[chunkId] + ".chunk.js";
};